export const SYSTEM_EVENT_DEFINITION_TYPE = "system-notifications-v1";
const getEventDefinitionTableElements = (pluggableAttributes) => {
  const defaultLayout = {
    entityTableId: "event_definitions",
    defaultPageSize: 20,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: [
      "title",
      "description",
      "priority",
      "scheduling",
      "status",
      "matched_at",
      ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) || []
    ],
    defaultColumnOrder: [
      "title",
      "description",
      "priority",
      "_entity_source.source",
      "matched_at",
      "status",
      "scheduling",
      ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) || []
    ]
  };
  const additionalAttributes = [
    { id: "scheduling", title: "Scheduling", sortable: false },
    { id: "matched_at", title: "Last Matched", sortable: true },
    ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributes) || []
  ];
  return {
    defaultLayout,
    additionalAttributes
  };
};
export default getEventDefinitionTableElements;
